// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zGha","newExpiryDate":"styles_newExpiryDate__wJwTN","footer":"styles_footer__3rSwn"};